import { render, staticRenderFns } from "./z3Cell.vue?vue&type=template&id=487769c1&scoped=true&"
import script from "./z3Cell.vue?vue&type=script&lang=js&"
export * from "./z3Cell.vue?vue&type=script&lang=js&"
import style0 from "./z3Cell.vue?vue&type=style&index=0&id=487769c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487769c1",
  null
  
)

export default component.exports